import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { addOrRemove, cloneDeep, compose, hashArray } from '@elliemae/ds-utilities/utils';
import { toggleInObject, filterMovedItems, getHierarchyTypeName } from './helper.js';
import utils from './utils.js';
import 'treetabular';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function toggleItemSelection(itemId) {
  return function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      checkedItems: addOrRemove(state.checkedItems, itemId)
    });
  };
}
function navigateTo(item, dest) {
  var hierarchyType = getHierarchyTypeName(dest);
  return function (state) {
    var indexInHierarchy = state[hierarchyType].findIndex(function (hItem) {
      return hItem.id === item.id;
    });
    var hierarchy = state[hierarchyType];
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, hierarchyType, indexInHierarchy !== -1 ? hierarchy.slice(0, indexInHierarchy + 1) : [].concat(_toConsumableArray(hierarchy), [item])));
  };
}
function moveItem(item) {
  return function (state) {
    var movedItems = toggleInObject(state.movedItems, item.id, item);
    return _objectSpread(_objectSpread({}, state), {}, {
      movedItems: movedItems
    });
  };
}
var defaultOptions = {
  parentField: 'parent',
  idField: 'id',
  op: function op(hasMoved) {
    return !hasMoved;
  }
}; // todo: optimize this

function getItemDeep(_ref) {
  var collection = _ref.collection,
      id = _ref.id,
      options = _ref.options;

  var _defaultOptions$optio = _objectSpread(_objectSpread({}, defaultOptions), options),
      idField = _defaultOptions$optio.idField;

  var itemIndex = collection.findIndex(function (fItem) {
    return fItem[idField] === id;
  }); // get item with nested children

  var item = collection[itemIndex];
  var children = item !== null && item !== void 0 && item.hasChildren ? compose(utils.getChildren({
    index: itemIndex
  }))(collection) || [] : [];
  return {
    item: item,
    children: children
  };
}

function addToTarget(itemToAdd, collection) {
  return function (state, _ref2) {
    var idField = _ref2.idField;
    var items = collection || state.preparedItems;

    var _getItemDeep = getItemDeep({
      collection: items,
      id: itemToAdd[idField]
    }),
        item = _getItemDeep.item,
        children = _getItemDeep.children;

    return _objectSpread(_objectSpread({}, state), {}, {
      movedItems: [].concat(_toConsumableArray(state.movedItems), [item]),
      targetItems: [].concat(_toConsumableArray(state.targetItems), [item], _toConsumableArray(children))
    });
  };
} // todo: optimize this

function removeFromTarget(itemToRemove) {
  return function (state, _ref3) {
    var idField = _ref3.idField;
    var targetItems = cloneDeep(state.targetItems);
    var itemIndex = targetItems.findIndex(function (fItem) {
      return fItem.id === itemToRemove.id;
    });
    var item = targetItems[itemIndex];
    var children = item !== null && item !== void 0 && item.hasChildren ? compose(filterMovedItems(state.movedItems), utils.getChildren({
      index: itemIndex
    }))(targetItems) || [] : [];
    targetItems.splice(itemIndex, 1);

    if (item !== null && item !== void 0 && item.hasChildren && children.length) {
      var childrenHash = hashArray(children, 'id');
      targetItems = targetItems.filter(function (i) {
        return !childrenHash[i.id];
      });
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      movedItems: state.movedItems.filter(function (mItem) {
        return mItem[idField] !== itemToRemove[idField];
      }),
      targetItems: targetItems
    });
  };
}
function resetCheckedItems() {
  return function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      checkedItems: []
    });
  };
}
function resetMovedItems() {
  return function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      movedItems: [],
      targetItems: []
    });
  };
}

export { addToTarget, moveItem, navigateTo, removeFromTarget, resetCheckedItems, resetMovedItems, toggleItemSelection };
//# sourceMappingURL=Shuttle.actions.js.map
